import React from "react";
import { Routes, Route } from "react-router-dom";

import { PartnerStatusUpdate } from "../pages/PartnerStatus/index";

const PartnerStatus = () => {
  return (
    <Routes>
      <Route path='/partner/status/:signature' element={<PartnerStatusUpdate />} />
    </Routes>
  );
};

export default PartnerStatus;
